export class EmployeeGoalSave {
    employeeId: number;
    employeeGoalIds: number[];
}
